import React from 'react';
import PropTypes from 'prop-types';
import Alert from '@welldev-group/rcl-alert';
import Button from '@welldev-group/rcl-button';
import DateTime from '../../DateTime';

const PendingDowngradeAlert = ({ isVisible, scheduledDowngrade, onClick }) => {
  return (
    <Alert
      className="pending-downgrade-alert"
      isVisible={isVisible}
      type="warning-light"
      hideClose={true}
    >
      <div className="pending-downgrade-alert__content">
        <div className="pending-downgrade-alert__content-text">
          {I18n.t('components.subscription.pending_downgrade_alert.text', {
            newPlanName: I18n.t(scheduledDowngrade && scheduledDowngrade.plan?.name, {
              scope: 'components.plans',
            }),
            newPlanPeriod: scheduledDowngrade?.plan?.period,
            date: DateTime({
              dateTime: scheduledDowngrade?.downgradeAt,
              format: 'short',
              returnStringOnly: true,
            }),
          })}
        </div>
        <Button
          className="pending-downgrade-alert__content-button"
          size="small"
          type="default"
          label={I18n.t('components.subscription.pending_downgrade_alert.button.label')}
          onClick={onClick}
        />
      </div>
    </Alert>
  );
};

PendingDowngradeAlert.defaultProps = {
  isVisible: true,
  scheduledDowngrade: null,
  onClick: () => {},
};

PendingDowngradeAlert.propTypes = {
  isVisible: PropTypes.bool,
  scheduledDowngrade: PropTypes.shape({
    plan: PropTypes.shape({
      name: PropTypes.string,
      period: PropTypes.string,
    }),
    downgradeAt: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

export default PendingDowngradeAlert;
